<template>
<div>
  <div class="row" v-if="showDisplayData()">
      <div class="col-lg-3 col-sm-6" v-if="showDisplaysOnlinePercentage()">
        <circle-chart-card :percentage="displaysOnlinePercentage"
                          :key="displaysOnlinePercentage"
                          chart-id="email-statistics-chart"
                          :title="$t('overview.devices')"
                          :description="$t('overview.normal')"
                          color="green"
                          :height="295">
          <template slot="footer">
            <div class="legend"><i class="fa fa-circle" style='color: green'></i> {{ $t('overview.online') }} </div>
            <hr>
            <div class="stats"><i class="fa fa-clock-o"></i> {{ $t('overview.updated_now') }} </div>
          </template>
        </circle-chart-card>
      </div>
       <div class="col-lg-3 col-md-6 col-sm-6" v-if="showInfopointStatus()">
            <stats-card type="success"
                        icon="nc-icon nc-check-2"
                        :small-title="$t('overview.online')"
                        :title="displaysOnline"
                        @click.native="goto('/devices/infopoints?status=online')"
                        class="link">
                <div class="stats" slot="footer"><i class="nc-icon nc-refresh-69"></i> {{ $t('overview.updated_now') }} <i class="nc-icon nc-minimal-right float-right"></i></div>
            </stats-card>
            <stats-card type="warning"
                        icon="nc-icon nc-simple-delete"
                        :small-title="$t('overview.offline-1')"
                        :title="displaysOffline"
                        @click.native="goto('/devices/infopoints?status=offline-1')"
                        class="link">
              <div class="stats" slot="footer"><i class="nc-icon nc-refresh-69"></i> {{ $t('overview.updated_now') }} <i class="nc-icon nc-minimal-right float-right"></i></div> 
            </stats-card>
            <stats-card type="danger"
                        icon="nc-icon nc-simple-delete"
                        :small-title="$t('overview.offline-2')"
                        :title="displaysOffline2"
                        @click.native="goto('/devices/infopoints?status=offline-2')"
                        class="link">
              <div class="stats" slot="footer"><i class="nc-icon nc-refresh-69"></i> {{ $t('overview.updated_now') }} <i class="nc-icon nc-minimal-right float-right"></i></div>
            </stats-card>
       </div>
      <div class="col-lg-6 col-sm-6" v-if="showDeviceOverview()">
        <card>
          <template slot="header">
            <h4 class="card-title">{{ $t('overview.devices') }}</h4>
            <p class="category">{{ $t('overview.online') }} - {{ $t('overview.period') }}</p>
          </template>
          <line-chart :labels="deviceChartData.labels"
                      :height="200"
                      :color="deviceChartData.color"
                      :extra-options="deviceChartData.options"
                      :data="deviceChartData.data">
          </line-chart>
      </card>
    </div>
  </div>

  <hr class="solid" v-if="showDisplayData() && showDepartureData()">

  <div class="row" v-if="showDepartureData()">
      <div class="col-lg-3 col-md-6 col-sm-6" v-if="showTodayDepartures() || showTodayForecasts() || showTodayBlockSequences()">
        <stats-card type="primary" 
                    icon="nc-icon nc-bullet-list-67"  
                    :small-title="$t('overview.today.departures')"
                    :title="departureCount"
                    v-if="showTodayDepartures()">
          <div class="stats" slot="footer"><i class="nc-icon nc-refresh-69"></i>{{ $t('overview.updated_now') }}</div>
        </stats-card>
        <stats-card type="success"
                    icon="nc-icon nc-pin-3"
                    :small-title="$t('overview.today.forecasts')"
                    :title="forecastCount"
                    v-if="showTodayForecasts()">
          <div class="stats" slot="footer"><i class="nc-icon nc-refresh-69"></i>{{ $t('overview.updated_now') }}</div> 
        </stats-card>
        <stats-card type="default"
                    icon="nc-icon nc-bus-front-12"
                    :description="$t('overview.block_sequence_info')"
                    :small-title="$t('overview.block_sequence')"
                    :title="blockSequenceCount"
                    @click.native="goto('/realtime/drivingCycles')"
                    class="link"
                    v-if="showTodayBlockSequences()">
          <div class="stats" slot="footer"><i class="nc-icon nc-refresh-69"></i>{{ $t('overview.updated_now') }}</div> 
        </stats-card>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6" v-if="showTodayCanceled() || showTodayInfo()">
        <stats-card type="danger"
                  icon="nc-icon nc-simple-remove"
                  :small-title="$t('overview.today.cancelled')"
                  :title="cancelledDeparturesCount"
                  v-if="showTodayCanceled()">
          <div class="stats" slot="footer"><i class="nc-icon nc-refresh-69"></i>{{ $t('overview.updated_now') }}</div>
        </stats-card>
        <stats-card type="info"
                    icon="nc-icon nc-alert-circle-i"
                    :small-title="$t('overview.today.infos')"
                    :title="validInfosCount"
                    @click.native="goto('/content/info')"
                    class="link"
                    v-if="showTodayInfo()">
          <div class="stats" slot="footer"><i class="nc-icon nc-refresh-69"></i>{{ $t('overview.updated_now') }} <i class="nc-icon nc-minimal-right float-right"></i></div>
        </stats-card>
        <departure-statistics-card v-if="showCurrentlyDrivenDepartureStatistics()">
        </departure-statistics-card>
      </div>
      <div class="col-lg-6 col-sm-6" v-if="showOverviewDepartures()">
        <card>
          <template slot="header">
            <h4 class="card-title">{{ $t('overview.departures') }}</h4>
            <p class="category">{{ $t('overview.period') }}</p>
          </template>
          <bar-chart :labels="departuresChartData.labels"
                     :height="200"
                     :datasets="departuresChartData.datasets">
          </bar-chart>
        </card>
      </div>
    </div>
</div>
</template>

<script>


import BarChart from 'src/components/UIComponents/Charts/BarChart'
import StatsCard from 'src/components/UIComponents/Cards/StatsCard'
import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard'
import DepartureStatisticsCard from 'src/components/UIComponents/Cards/DepartureStatisticsCard'

import LineChart from 'src/components/UIComponents/Charts/LineChart'
import overview from '@/store/system/overview'

export default {
    components: {
        BarChart,
        StatsCard,
        CircleChartCard,
        LineChart,
        DepartureStatisticsCard
    },
    data () {
      return {
        departuresChart: {
          labels: ["...", "...", "...", "...", "...", "...", "...", "...", "...", "..."],
          datasets: [
            {
              label: this.$t('overview.departures'),
              borderColor: '#fcc468',
              fill: true,
              backgroundColor: '#fcc468',
              hoverBorderColor: '#fcc468',
              borderWidth: 5,
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            },
             {
              label: this.$t('overview.predictions'),
              borderColor: '#28a745',
              fill: true,
              backgroundColor: '#28a745',
              hoverBorderColor: '#28a745',
              borderWidth: 5,
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            }
          ]
        },
        deviceChart: {
          labels: ["...", "...", "...", "...", "...", "...", "...", "...", "...", "..."],
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          color: '#6bd098'
        }
      }
    },
    computed: {
        displaysOnline() {
          return this.numberValueToViewString(this.$store.state.overview.systemOverview.DISPLAYS_ONLINE);
        },
        displaysOffline() {
          return this.numberValueToViewString(this.$store.state.overview.systemOverview.DISPLAYS_OFFLINE);
        },
        displaysOffline2() {
          return this.numberValueToViewString(this.$store.state.overview.systemOverview.DISPLAYS_OFFLINE_2);
        },
        displaysOnlinePercentage(){
          const dOn = this.$store.state.overview.systemOverview.DISPLAYS_ONLINE;
          const dOff = this.$store.state.overview.systemOverview.DISPLAYS_OFFLINE;
          const dOff2 = this.$store.state.overview.systemOverview.DISPLAYS_OFFLINE_2;
          const dOnPercent = Math.round( dOn / (dOn + dOff + dOff2) * 100);
          if (!isNaN(dOnPercent)) return dOnPercent;
          return 0;
        },
        departureCount() {
          return this.numberValueToViewString(this.$store.state.overview.systemOverview.DEPARTURE_COUNT);
        },
        forecastCount() {
          return this.numberValueToViewString(this.$store.state.overview.systemOverview.FORECAST_COUNT);
        },
        cancelledDeparturesCount() {
          return this.numberValueToViewString(this.$store.state.overview.systemOverview.CANCELLED_DEPARTURES_COUNT);
        },
        validInfosCount() {
          return this.numberValueToViewString(this.$store.state.overview.systemOverview.VALID_INFOS_COUNT);
        },
        blockSequenceCount() {
          const bSC = this.$store.state.overview.systemOverview.BLOCK_SEQUENCE_COUNT;
          const bSAC = this.$store.state.overview.systemOverview.BLOCK_SEQUENCE_ASSIGNED_COUNT;
          const bSNAC = this.$store.state.overview.systemOverview.BLOCK_SEQUENCE_NOT_ASSIGNED_COUNT;
          return `${this.numberValueToViewString(bSC)} / ${this.numberValueToViewString(bSAC)} / ${this.numberValueToViewString(bSNAC)}`;
        },
        departuresChartData() {
          return this.updateDeparturesChart(this.$store.state.overview.systemOverview.DEPARTURE_HISTORY);
        },
        deviceChartData() {
          return this.updateDeviceChart(this.$store.state.overview.systemOverview.DISPLAY_HISTORY);
        }
    },
    created(){
        if (!this.$store.state.overview) {
            this.$store.registerModule("overview" , overview);
        }
        this.$store.dispatch('overview/getSystemOverview');
    },
    methods: {
      goto(route){
         this.$router.push(route);    
      },
      numberValueToViewString(value) {
        if (typeof value == 'number') {
          return value.toString();
        }
        return '...';
      },
      updateDeparturesChart(departureHistoryList) {
        let dates = [];   
        let departureHistory = [];
        let forecastHistory = [];
        if(Array.isArray(departureHistoryList)) {
          try {
            departureHistoryList.forEach( h => {
              dates.push(h.date)
              departureHistory.push(h.departures);
              forecastHistory.push(h.forecasts);   
            });
            this.departuresChart.datasets[0].data = departureHistory;
            this.departuresChart.datasets[1].data = forecastHistory;
            this.departuresChart.labels = dates;
          } catch (error) {
            console.error(error);
          }
        }
        return this.departuresChart;
      },
      updateDeviceChart(displayHistoryList) {
        let deviceDates = [];
        let onlineHistory = [];
        if(Array.isArray(displayHistoryList)) {
          try {
            displayHistoryList.forEach( h => {
              deviceDates.push(h.date);
              onlineHistory.push(h.online);
            });
            this.deviceChart.labels = deviceDates;
            this.deviceChart.data = onlineHistory;
          } catch (error) {
            console.error(error);
          }
        }
        return this.deviceChart;
      },
      showDisplayData() {
        return this.$UiConfig('/ui/view/system/overview/showDisplayData', true);
      },
      showDepartureData() {
        return this.$UiConfig('/ui/view/system/overview/showDepartureData', true);
      },
      showDisplaysOnlinePercentage() {
        return this.$UiConfig('/ui/view/system/overview/showDisplaysOnlinePercentage', true)
      },
      showInfopointStatus() {
        return this.$UiConfig('/ui/view/system/overview/showInfopointStatus', true)
      },
      showDeviceOverview() {
        return this.$UiConfig('/ui/view/system/overview/showDeviceOverview', true)
      },
      showTodayDepartures() {
        return this.$UiConfig('/ui/view/system/overview/showTodayDepartures', true)
      },
      showTodayForecasts() {
        return this.$UiConfig('/ui/view/system/overview/showTodayForecasts', true)
      },
      showTodayCanceled() {
        return this.$UiConfig('/ui/view/system/overview/showTodayCanceled', true)
      },
      showTodayInfo() {
        return this.$UiConfig('/ui/view/system/overview/showTodayInfo', true)
      },
      showOverviewDepartures() {
        return this.$UiConfig('/ui/view/system/overview/showOverviewDepartures', true)
      },
      showTodayBlockSequences() {
        return this.$UiConfig('/ui/view/system/overview/showTodayBlockSequences', true)
      },
      showCurrentlyDrivenDepartureStatistics() {
        return this.$UiConfig('/ui/view/system/overview/showCurrentlyDrivenDepartureStatistics', true);
      }
    }
}
</script>


<style scoped lang="scss">



.card-stats.link {
   cursor: pointer;
}

hr.solid {
  border-top: 2px solid #ddd;
  border-radius: 5px;
  margin-bottom: 2rem;
 
}

</style>
